<template>
    <div class="page-mobile">
        <div class="bgMobile"></div>
        <div class="mobileMask"></div>
        <div class="mobileContain">
            <img src="@/assets/images/logo.png" class="mobileLogo" />
            <p class="mobileTitle">天台生活</p>
            <p class="mobileDesc">本地生活资讯,发现身边好玩的事情</p>
            <div class="mobilePicContain">
                <img src="@/assets/images/phone1.png" class="mobileLeftPic" />
                <img src="@/assets/images/phone2.png" class="mobileLeftPic" />
            </div>
            <div class="mobileDownloadBtm" @click="toOpenApp">点击下载</div>
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        toOpenApp(){
            this.$router.push("/openApp")
        }
    }
}
</script>
<style scoped>
.page-mobile{display:none;min-width:320px}
/*背景和蒙版*/
.bgMobile{position:fixed;left:0;top:0;width:100%;height:100%;z-index:-100;background-image:url("@/assets/images/mobileBack.jpg");background-size:cover}
.mobileMask{position:fixed;top:0;left:0;width:100%;height:100%;z-index:-10;background:rgba(0,0,0,.35)}
/*容器 */
.mobileContain{width:100vw;height:100vh;padding:32px 20px;display:flex;flex-direction:column;justify-content:flex-start;align-items:center}
.mobileLogo{width:120px;height:120px;border-radius:10px}
.mobileTitle{font-size:16px;color:#fff;line-height:40px}
.mobileDesc{font-size:14px;color:#ffffff80;line-height:20px}
/*图片*/
.mobilePicContain{margin-top:20px;display:flex;flex-direction:row;justify-content:space-between}
.mobileLeftPic{width:48%}
/*下载按钮*/
.mobileDownloadBtm{width:100%;height:48px;background-color:#FFF;justify-content:center;align-items:center;text-align:center;font-weight:500;font-size:16px;line-height:48px;margin-top:20px;border-radius:10px;color:#121212}
</style>